import { useState } from "react";
import { useTheme } from "styled-components";

import { lang } from "../assets/languages/en.language";
import Popup from "../components/Popup.component";
import { BellIcon } from "../components/svgs/icons/Bell.icon";
import LocationIcon from "../components/svgs/icons/Location.icon";
import { Swiper } from "../components/Swiper.component";
import { useGeolocation } from "../hooks/useGeolocation";
import { usePushNotifications } from "../hooks/usePushNotifications";
import { RootContainer } from "../styles/Container.style";

export default function SwiperPage() {
  const theme = useTheme();
  const [showPushPopup, setShowPushPopup] = useState(true);
  const { permission: geoPermission, loading: geoLoading, getLocation } = useGeolocation();
  const { permission: pushPermission, loading: pushLoading, getPushPermission } = usePushNotifications();


  return (
    <RootContainer $background={theme.color.primaryExtraLight}>
      {geoPermission == "granted" && pushPermission != "prompt" && <Swiper />}
      {/* {notificationFlags == null && (
        <Popup
          type="info"
          title={lang.swiperPage.notificationPermissionRequestPopup.title}
          message={lang.swiperPage.notificationPermissionRequestPopup.message}
          buttonText={lang.swiperPage.notificationPermissionRequestPopup.buttonText}
          cancelButtonText={lang.swiperPage.notificationPermissionRequestPopup.cancelButtonText}
          Icon={BellIcon}
          onClose={() => onEmailNotifResponse(false)}
          action={() => onEmailNotifResponse(true)}
        />
      )} */}

      {geoPermission == "granted" && pushPermission == "prompt" && showPushPopup && (
        <Popup
          type="info"
          title={lang.swiperPage.notificationPermissionRequestPopup.title}
          message={lang.swiperPage.notificationPermissionRequestPopup.message}
          buttonText={lang.swiperPage.notificationPermissionRequestPopup.buttonText}
          cancelButtonText={lang.swiperPage.notificationPermissionRequestPopup.cancelButtonText}
          Icon={BellIcon}
          onClose={() => setShowPushPopup(false)}
          action={getPushPermission}
          isLoading={pushLoading}
        />
      )}


      {geoPermission != "granted" && (
        <Popup
          type="info"
          title={lang.swiperPage.geolocationPermissionRequestPopup.title}
          message={lang.swiperPage.geolocationPermissionRequestPopup.message}
          buttonText={lang.swiperPage.geolocationPermissionRequestPopup.buttonText}
          Icon={LocationIcon}
          onClose={() => {}}
          action={getLocation}
          isLoading={geoLoading}
        />
      )}
    </RootContainer>
  );
}
